// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inputText {\n  width: 70%;\n}\n.bottomDiv {\n  width: 100%;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
